export const SERVICE_TYPE = {
    SKI: 'ski',
    SNB: 'snb',
    WEX: 'wex',
    KID_SCHOOL: 'kid_school',
    STAFF: 'staff',
    STORNO: 'storno',
};
